<template>
  <div class="consultation-step2">
    <div class="consultation-step2__layout">
      <div class="consultation-step2__search-box">
        <div class="consultation-step2__location-block">
          <p
            v-show="error"
            class="consultation-step2__location-block-error"
          >
            {{ _.get(translate, 'coordinatesNotFound', '') }}
          </p>
          <SearchField
            v-show="!pageHasQueryParam"
            ref="SearchField"
            :placeholder="fields.location.label"
            @clickSearchIcon="clickSearchIcon"
          />
          <!--          <div-->
          <!--            v-show="!pageHasQueryParam"-->
          <!--            class="consultation-step2__geo-location"-->
          <!--            @click="getCurrentGeoLocation"-->
          <!--          >-->
          <!--            <span class="icon icon-locate" />-->
          <!--            <span class="consultation-step2__geo-location-text">-->
          <!--              {{ buttons.myLocation.label }}-->
          <!--            </span>-->
          <!--          </div>-->
        </div>
        <div
          ref="searchResult"
          class="consultation-step2__search-results scrollable"
          :class="{'consultation-step2__search-results_min-height': isGetFilterDealers}"
        >
          <Filters
            v-if="(isShowDetailsElements && !isHideFilter && !isLocalStorage) || isGetFilterDealers"
            :items="fields.services.items"
            :filterUpdateButton="buttons.filterUpdate"
            :placeholder="fields.services.label"
            @input="getFilterDealers"
          />
          <div
            class="consultation-step2__search-results-list"
          >
            <div
              v-for="(item, itemIndex) in items"
              :key="`item-${itemIndex}`"
              ref="$items"
              class="consultation-step2__search-results-list-item"
              :class="{'consultation-step2__search-results-list-item_is-local-storage': isLocalStorage}"
              @click="onMarkerClick(itemIndex)"
            >
              <span
                v-show="!isLocalStorage"
                class="consultation-step2__search-results-list-item-index"
              >
                {{ itemIndex + 1 }}
              </span>
              <div class="consultation-step2__search-results-list-item-name">
                {{ item.text }}
              </div>
              <div class="consultation-step2__search-results-list-item-address-lines">
                <div
                  v-for="(adr, adrIndex) in item.address"
                  :key="`adr-${adrIndex}`"
                  class="consultation-step2__search-results-list-item-address"
                >
                  {{ adr }}
                </div>
              </div>

              <BaseButton
                v-if="detailsToggleData[itemIndex]"
                class="consultation-step2__search-results-list-item-button"
                @click="chooseDealer(itemIndex)"
              >
                {{ buttons.submit.label }}
              </BaseButton>

              <div
                v-show="detailsToggleData[itemIndex]"
                class="consultation-step2__search-results-list-item-details"
              >
                <template v-if="!$resp.sm">
                  <div
                    :key="1"
                    class="consultation-step2__search-results-list-item-details-item"
                  >
                    <div
                      class="consultation-step2__search-results-list-item-details-item-title"
                    >
                      <div>{{ title }}</div>
                      <strong>{{ hint }}</strong>
                    </div>
                    <h5 class="consultation-step2__search-results-list-item-details-item-name">
                      {{ showroom }}
                    </h5>
                    <div class="consultation-step2__search-results-list-item-details-opening">
                      <div
                        v-for="(showroomItem, showroomItemIndex) in item.showroom"
                        :key="`cto-${showroomItemIndex}`"
                        class="consultation-step2__search-results-list-item-details-opening-item"
                      >
                        {{ showroomItem }}
                      </div>
                    </div>
                  </div>
                  <div v-if="item.cto" class="consultation-step2__search-results-list-item-details-item">
                    <div class="consultation-step2__search-results-list-item-details-item-title">
                      <div>{{ title }}</div>
                      <strong>{{ hint }}</strong>
                    </div>
                    <h5 class="consultation-step2__search-results-list-item-details-item-name">
                      {{ work }}
                    </h5>
                    <div v-if="item.cto" class="consultation-step2__search-results-list-item-details-opening">
                      <div
                        v-for="(cto, ctoIndex) in item.cto"
                        :key="`cto-${ctoIndex}`"
                        class="consultation-step2__search-results-list-item-details-opening-item"
                      >
                        {{ cto }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    :key="2"
                    class="consultation-step2__search-results-list-item-details-item"
                  >
                    <div
                      class="consultation-step2__search-results-list-item-details-item-title"
                      @click="toggleList"
                    >
                      <div>{{ title }}</div>
                      <strong>{{ hint }}</strong>
                      <ChevronIcon
                        ref="arrow"
                        class="consultation-step2__search-results-list-item-details-item-title-arrow"
                      />
                    </div>
                    <div
                      ref="list"
                      class="consultation-step2__search-results-list-item-details-item-list"
                    >
                      <h5 class="consultation-step2__search-results-list-item-details-item-name">
                        {{ showroom }}
                      </h5>
                      <div class="consultation-step2__search-results-list-item-details-opening">
                        <div
                          v-for="(showroomItem, showroomItemIndex) in item.showroom"
                          :key="`cto-${showroomItemIndex}`"
                          class="consultation-step2__search-results-list-item-details-opening-item"
                        >
                          {{ showroomItem }}
                        </div>
                      </div>
                      <template >
                        <h5 class="consultation-step2__search-results-list-item-details-item-name">
                          {{ work }}
                        </h5>
                        <div class="consultation-step2__search-results-list-item-details-opening">
                          <div
                            v-for="(cto, ctoIndex) in item.cto"
                            :key="`cto-${ctoIndex}`"
                            class="consultation-step2__search-results-list-item-details-opening-item"
                          >
                            {{ cto }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div
            v-if="isShowMoreButton && isShowDetailsElements && !isLocalStorage"
            class="consultation-step2__search-results-show-more"
          >
            <BaseButton
              type="secondary-arrow"
              @click="showMore"
            >
              {{ buttons.showMore.label }}
            </BaseButton>
          </div>
        </div>
      </div>
      <div class="consultation-step2__map map" />
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { config } from '../../../config'
  import isEmpty from 'lodash/isEmpty'

  import SearchField from '../SearchField'
  import ChevronIcon from '@/assets/img/icons/chevron.svg?inline'
  import Filters from '../Filters'

  export default {
    name: 'ConsultationStep2',

    components: {
      SearchField,
      Filters,
      ChevronIcon
    },

    props: {
      dealerListUrl: String,
      buttons: Object,
      title: String,
      showroom: String,
      work: String,
      hint: String,
      fields: Object,
      translate: Object
    },

    data () {
      return {
        error: false,
        language: this.$store.state.currentLang,
        country: this.$store.state.currentCountry,
        dealers: [],
        dealersSort: [],
        currentGeoLocation: {
          latitude: '',
          longitude: ''
        },
        pageHasQueryParam: false,

        items: [],

        markers: [],

        detailsToggleData: [],

        minItemsCount: 5,
        minItemsCountStep: 5,

        distances: [],

        isHideFilter: false,

        isLocalStorage: false,

        isGetFilterDealers: false,
        localStorageVer: '1'
      }
    },

    computed: {
      ...mapState({
        currentLang: state => state.currentLang,
        currentCountry: state => state.currentCountry
      }),

      isShowMoreButton () {
        return this.minItemsCount < this.dealers.length
      },

      isShowDetailsElements () {
        return this.items && this.items.length
      }
    },

    watch: {
      currentGeoLocation: {
        async handler (v) {
          this.getNearMarkers()
        },

        deep: true
      },

      minItemsCount () {
        this.getNearMarkers()
      },

      'detailsToggleData': {
        handler (v) {
          if (this.$resp.sm && this.$refs.list && this.$refs.list.length) {
            if (v) {
              Array.from(this.$refs.list).forEach(el => {
                el.style.height = 0
              })
            }
          }
        },

        deep: true
      }
    },

    created () {
      this.getAllDealers(true)
    },

    mounted () {
      this.initMap()
      this.initAutoComplete()
    },

    methods: {
      pushDataToDataLayer (params = { events: {
        name: 'formevent',
        componentName: 'book-dealer-appointment',
        componentGroup: 'forms',
        action: 'form-step',
        label: 'select-dealer'
      } }, pushDataLayer = false, dataForDataLayer = { 'event': 'formevent' }) {
        const event = params.events

        const page = {
          category: 'tools',
          subCategory: 'form',
          sectionlv1: 'forms',
          sectionlv2: 'book-dealer-appointment',
          language: _.get(this, 'language', '') || _.get(this, 'currentLang', '')
        }

        const form = {
          name: 'lead-book-dealer-appointment',
          step: 'select-dealer',
          conversion: '0'
        }

        const modelId = _.get(this, '$store.state.consultation.step1.modelId', '')
        const modelName = _.get(this, '$store.state.consultation.step1.modelText', '')

        const product = [{
          category: 'cars',
          subCategory: 'new-cars',
          productInfo: {
            productId: modelId,
            productName: modelName,
            tmeModelId: modelId,
            modelName
          }
        }]

        window.tngaDataLayer = { event, page, form, product }
        if (pushDataLayer) {
          window.dataLayer.push(dataForDataLayer)
        }
      },

      isAllDealers (allDealers) {
        const itemsLocalStorage = this.getStorageDealer()
        const itemsLocalStorageNew = itemsLocalStorage.map(item => _.omit(item, 'distance'))
        const newDealersListLocal = itemsLocalStorageNew.map(item => _.includes(JSON.stringify(allDealers), JSON.stringify(item)))
        const needChangedLocal = newDealersListLocal.some(item => item === false)

        if (needChangedLocal) {
          localStorage.removeItem('mytoyota' + this.localStorageVer + this.currentLang)

          newDealersListLocal.map((item, index) => {
            if (!item) itemsLocalStorage.splice(index, 1)
          })

          localStorage.setItem('mytoyota' + this.localStorageVer + this.currentLang, JSON.stringify({
            items: itemsLocalStorage
          }))
        }

        if (!_.isEmpty(itemsLocalStorage)) {
          this.isLocalStorage = true
          this.items = itemsLocalStorage.reverse()
        }
      },

      toggleList (e) {
        if (this.$resp.sm) {
          e.stopPropagation()
          const el = e.currentTarget
          const next = el.nextElementSibling
          if (next.classList.contains('consultation-step2__search-results-list-item-details-item-list')) {
            if (!parseInt(el.nextElementSibling.style.height)) {
              next.classList.add('active')
              el.classList.add('active')
              next.style.height = next.scrollHeight + 'px'
            } else {
              next.classList.remove('active')
              el.classList.remove('active')
              next.style.height = 0
            }
          }
        }
      },

      async chooseDealer (index) {
        try {
          const sendData = {
            dealer: this.items[index].value
          }

          await window.axios.post(this.buttons.submit.url, sendData)
          this.$store.commit('consultation/SET_STEP2', {
            ...sendData,
            dealersText: this.items[index].text,
            dealerId: this.items[index].dealerId || '',
            dealerCity: this.items[index].city,
            dealerZipCode: this.items[index].zipcode || ''
          })

          this.pushDataToDataLayer(undefined)

          this.$store.commit('consultation/SET_SHOWROOM_PERIOD', _.get(this.items[index], 'showroomPeriod', {}))
          this.$store.commit('consultation/SET_FOR_POLICY', _.get(this.items[index], 'forPolicy', {}))

          this.$emit('nextStep')
        } catch (e) {
          console.log(e.response)
        }
      },

      showMore () {
        this.minItemsCount += this.minItemsCountStep
      },

      addDetailsToggleData () {
        this.items.forEach((item, itemIndex) => {
          this.$set(this.detailsToggleData, itemIndex, false)
        })
      },

      animateMarker (index) {
        if (!this.map.markers && !this.map.markers[index]) return
        this.map.markers[index].animate()
      },

      async showDetails (index) {
        this.addDetailsToggleData()
        this.$set(this.detailsToggleData, index, true)
        this.isHideFilter = true
        if (!this.isLocalStorage) {
          this.animateMarker(index)
        } else {
          this.map.clearMarkers()
          await this.map.addMarkers([this.items[index]], {
            markerImage: 'toyota-red-text',
            text: true,
            markerClick: this.onMarkerClick
          })

          await this.map.fitBoundsToMarkers({
            maxZoom: 13
          })
        }
      },

      async initMap () {
        const $map = this.$el.querySelector('.map')
        if (!$map) return
        this.map = await new window.mapsWrapper.DynamicMap($map, {
          accessToken: config.MAP_KEY,
          language: this.language,
          countryCode: this.country,
          addCountryBoundaries: this.country,
          boundsPreservePaddingLeft: this.$resp.sm ? 0 : 400,
          boundsPreservePaddingBottom: this.$resp.sm ? 400 : 0,
          zoomControl: this.$resp.sm ? 'top-left' : 'bottom-right',
          maxZoom: 15
        })
      },

      async getCurrentGeoLocation () {
        this.error = false
        this.isGetFilterDealers = false
        this.minItemsCount = this.minItemsCountStep
        const currentlocation = await this.map.getCurrentGeoLocation()

        const [location] = await this.map.geoReverse(currentlocation, {
          fitToBounds: true,
          limit: 1
        })

        if (location instanceof Object && location.name) {
          this.input.value = location.name
        }

        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }

        const success = async (pos) => {
          await this.getAllDealers()
          const crd = pos.coords
          this.currentGeoLocation.latitude = crd.latitude
          this.currentGeoLocation.longitude = crd.longitude

          const currentGeoLocationMarker = await this.map.addMarker([this.currentGeoLocation.longitude, this.currentGeoLocation.latitude], {
            markerImage: 'toyota-red-person'
          })

          this.getNearMarkers()

          this.isHideFilter = false
          this.isLocalStorage = false

          setTimeout(() => {
            currentGeoLocationMarker.remove()
          }, 3000)
        }

        function error (err) {
          this.error = true
          console.warn(`ERROR(${err.code}): ${err.message}`)
        }
        navigator.geolocation.getCurrentPosition(success, error, options)
      },

      async getAllDealers (updateLocalStorage = false) {
        const queryParams = {
          'per-page': 0
        }

        if (this.$route.query.city) {
          queryParams.city = this.$route.query.city
          this.pageHasQueryParam = true
        }

        if (this.$route.query.dealer) {
          queryParams.dealer = this.$route.query.dealer
        }

        try {
          const { data } = await window.axios.get(this.dealerListUrl, {
            params: queryParams
          })

          this.dealers = data.items

          updateLocalStorage && this.isAllDealers(this.dealers)

          if (this.$route.query.city) {
            this.getNearMarkers()
            this.isHideFilter = false
            this.isLocalStorage = false
            this.error = false
            this.isGetFilterDealers = false
            this.minItemsCount = this.minItemsCountStep
          }
        } catch (e) {
          console.log(e.response)
        }
      },

      async getFilterDealers (e) {
        this.isGetFilterDealers = true
        let params = e
        if (Array.isArray(params)) {
          params = params.join(',')
        }

        const queryParams = {
          'per-page': 0,
          'services': params
        }

        if (this.$route.query.city) queryParams.city = this.$route.query.city
        if (this.$route.query.dealer) queryParams.dealer = this.$route.query.dealer

        try {
          const { data } = await window.axios.get(this.dealerListUrl, {
            params: queryParams
          })

          this.map.clearMarkers()
          this.dealers = data.items
          this.getNearMarkers({ type: 'filter' })
        } catch (e) {
          console.log(e.response)
        }
      },

      getStorageDealer () {
        const object = JSON.parse(localStorage.getItem('mytoyota' + this.localStorageVer + this.currentLang))

        if (!_.isEmpty(object) && object.items && object.items.length) {
          return object.items
        }
        return []
      },

      setStorageDealer (index) {
        if (!this.isLocalStorage) {
          const currentItem = this.items[index]
          if (currentItem) {
            let object = JSON.parse(localStorage.getItem('mytoyota' + this.localStorageVer + this.currentLang))

            if (!_.isEmpty(object) && object.items && object.items.length) {
              object.items.push(currentItem)
              object.items = object.items.filter(item => _.get(item, 'value', '') !== _.get(currentItem, 'value', ''))
              object.items.push(currentItem)
            } else {
              object = {
                items: [currentItem]
              }
            }

            localStorage.setItem('mytoyota' + this.localStorageVer + this.currentLang, JSON.stringify({
              items: object.items
            }))
          }
        }
      },

      onMarkerClick (index) {
        const $el = this.$refs.$items[index]
        if ($el) {
          setTimeout(() => {
            this.$refs.searchResult.scrollTop = $el.offsetTop
          }, 100)
          this.showDetails(index)

          this.setStorageDealer(index)
        }
      },

      async getNearMarkers (params = { type: '', data: '' }) {
        const radius = 60
        const { type } = params
        this.markers = []
        this.items = []
        this.distances = []

        const distFromCenter = (checkPoint) => {
          const ky = 40000 / 360
          const kx = Math.cos(Math.PI * this.currentGeoLocation.latitude / 180.0) * ky
          const dx = Math.abs(this.currentGeoLocation.longitude - checkPoint.longitude) * kx
          const dy = Math.abs(this.currentGeoLocation.latitude - checkPoint.latitude) * ky
          this.distances.push(Math.sqrt(dx * dx + dy * dy))
          return Math.sqrt(dx * dx + dy * dy)
        }

        this.dealers = this.dealers.filter((item) => {
          if (!item.coordinates.hasOwnProperty('length')) {
            item.distance = distFromCenter(item.coordinates)
            if (type === 'filter') {
              if (item.distance < radius) {
                return item
              }
            } else {
              return item
            }
          }
        })

        this.dealers.sort((a, b) => {
          return a.distance - b.distance
        })

        this.markers = this.items = this.dealers.filter((item, itemIndex) => itemIndex < this.minItemsCount)

        if (this.markers && this.markers.length) {
          this.map.clearMarkers()
          await this.map.addMarkers(this.markers, {
            markerImage: 'toyota-red-text',
            text: true,
            markerClick: this.onMarkerClick
          })

          await this.map.fitBoundsToMarkers({
            maxZoom: 13
          })

          this.addDetailsToggleData()
        }
      },

      async initAutoComplete () {
        this.input = this.$refs.SearchField.$el.querySelector('input')
        this.autocomplete = new window.mapsWrapper.AutoComplete({
          autoCompleteInput: this.input,
          countryCode: this.country,
          minLength: 3,
          delay: 500,
          language: this.language,
          types: ['place', 'locality', 'neighborhood', 'region', 'postcode'],
          onLocationSelect: async (location) => {
            if (location instanceof Object) {
              [this.currentGeoLocation.longitude, this.currentGeoLocation.latitude] = location.coordinates
              await this.getAllDealers()
              this.getNearMarkers()
              this.isHideFilter = false
              this.isLocalStorage = false
              this.error = false
              this.isGetFilterDealers = false
              this.minItemsCount = this.minItemsCountStep
            } else {
              this.error = true
            }
          },
          accessToken: config.MAP_KEY
        })
      },

      async clickSearchIcon () {
        if (isEmpty(this.input.value)) return
        await this.getAllDealers()
        this.getNearMarkers()
        const [result] = await this.autocomplete.geocoder.search(this.input.value, {
          accessToken: config.MAP_KEY,
          limit: 1
        })
        if (result instanceof Object) {
          [this.currentGeoLocation.longitude, this.currentGeoLocation.latitude] = result.coordinates
          this.isHideFilter = false
          this.isLocalStorage = false
          this.error = false
          this.isGetFilterDealers = false
          this.minItemsCount = this.minItemsCountStep
        } else {
          this.error = true
        }
      }
    }
  }
</script>
<style lang="scss">
  .consultation-step2 {
    &__layout {
      position: relative;
      height: 586px;

      @media (max-width: 991px) {
        height: 486px;
      }

      @media (max-width: 767px) {
        margin: 0 -15px;
      }
    }

    &__map {
      width: 100%;
      height: 100%;
    }

    &__search-box {
      position: absolute;
      top: 10px;
      bottom: 0;
      left: 10px;
      z-index: 3;
      display: flex;
      flex-direction: column;
      width: 350px;
      max-height: calc(100% - 20px);
      overflow-y: auto;

      @include mobile {
        right: 15px;
        bottom: 15px;
        left: 15px;
        width: auto;
        margin-top: 50%;
      }
    }

    &__location-block {
      flex-shrink: 0;
      margin-bottom: 4px;
      overflow: hidden;
      background-color: $c-white;
      border-radius: 4px;

      &-error {
        padding: 15px 10px 15px 30px;
        font-size: 15px;
        font-weight: normal;
        color: $c-active;
        text-align: left;
        border-bottom: 1px solid $c-gray-extra-light-3;
      }

      .search-field {
        border-bottom: 1px solid $c-gray-extra-light-3;
      }
    }

    &__geo-location {
      padding: 15px 30px;
      line-height: 24px;
      cursor: pointer;

      $parent: &;

      @include hover() {
        #{$parent}-text {
          text-decoration: underline;
        }
      }

      .icon {
        color: $c-gray-dark;
      }

      &-text {
        color: $c-gray-dark;
      }
    }

    &__search-results {
      position: relative;
      overflow-x: hidden;
      overflow-y: auto;

      &_min-height {
        min-height: 300px;
      }

      @include mobile {
        overflow: visible;
      }

      .filters {
        margin-bottom: 4px;
      }

      &-show-more {
        padding: 30px;
        text-align: center;
        background-color: $c-white;
        border-radius: 4px;
      }

      &-list {
        &-item {
          position: relative;
          padding: 30px 30px 30px 60px;
          margin-bottom: 4px;
          cursor: pointer;
          background-color: $c-white;
          border-radius: 4px;

          &_is-local-storage {
            padding: 30px;
          }

          &-index {
            position: absolute;
            top: 24px;
            left: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 30px;
            height: 30px;
            line-height: 30px;
            color: $c-white;
            background-color: $c-active;
            border-radius: 50%;
          }

          &-name {
            font-size: 15px;
            font-weight: bold;
          }

          &-address-lines {
            margin-top: 15px;
          }

          &-address {
            font-size: 15px;
            line-height: 24px;
            color: $c-shadow-light;
          }

          &-button {
            min-width: 160px;
            max-width: 100%;
            margin-top: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &-details {
            &-item {
              &-title {
                margin: 32px 0;
                font-size: 16px;
                line-height: 24px;

                @include mobile () {
                  margin: 22px 0 0;
                }

                &-arrow {
                  width: 17px;
                  height: 17px;
                  margin-left: 2px;
                  vertical-align: bottom;
                  stroke: $c-shadow-light;
                  transition: 0.3s;
                  transform: rotate(-90deg);
                }

                &.active {
                  .consultation-step2__search-results-list-item-details-item-title-arrow {
                    transform: rotate(90deg);
                  }
                }
              }

              &-name {
                margin: 15px 0 10px;
                text-align: left;
              }

              &-list {
                overflow: hidden;
                transition: height 0.3s ease-in-out;
              }
            }

            &-opening {
              &-item {
                font-size: 15px;
                line-height: 24px;
                color: $c-shadow-light;
              }
            }
          }
        }
      }
    }
  }
</style>
